/**
 * 列表页搜索组件
 */
import subPageEventMixin from "utils/event/subPageEventMixin.js"
class ListPageSearchComponent {
  constructor(context) {
    ;(this.context = context),
      (this.simpleSearchButtonId = null),
      (this.clickSearchButtonBind = null),
      (this.searchButton = null)
  }
  init() {
    const uid = this.context.options?.rows[0]?.cols[0]?.uid
    const idPrefix = `container_id_${this.context.myid.container_id}-rect_id_${this.context.myid.rect_id}-uid_${uid}-elementInLayoutId_`
    this.simpleSearchButtonId = idPrefix + this.context.options.rows[0].cols[0].elementOptions.find(item => item.innerElement === "cxButton").elementInLayoutId
    this.searchButton = document.getElementsByClassName(this.simpleSearchButtonId)[0]
    if (this.searchButton) {
      this.clickSearchButtonBind = this.clickSearchButton.bind(this)
      this.searchButton.addEventListener("click", this.clickSearchButtonBind, true)
    }
  }
  clickSearchButton() {
    // 获取当前搜索的值
    const uid = this.context.options.rows[0].cols[0].uid
    const options = this.context.$getOptions({
      ...this.context.myid,
      uid: uid,
      elementInLayoutId: this.context.options.rows[0].cols[0].elementOptions.find(item => item.innerElement === "cxInput").elementInLayoutId
    })
    const searchInputValue = options.inputValue
    // 通知数据列表更新数据
    // this.context.$eventBus.$emit("subPage-component-init", {
    //   type: "cxDataGrid",
    //   sw: searchInputValue
    // })
    if (this.context.$subPageEvent.contexts) {
      Object.keys(this.context.$subPageEvent.contexts).forEach(key => {
        if (key.indexOf("cxDataGrid") !== -1) {
          ///this.$subPageEvent.contexts[key].initListPageDataGridData(this)
          this.$eventBus.$emit("subPage-component-init", {
            type: key,
            sw: searchInputValue
          })
        }
      })
    }
  }
  removeEventTrigger() {
    if (this.searchButton) {
      this.searchButton.removeEventListener("click", this.clickSearchButtonBind, true)
    }
  }
}
export default {
  methods: {
    ListPageSearchComponentPlugin() {
      const listPageSearchComponent = new ListPageSearchComponent(this)
      this.listPageSearchComponent = listPageSearchComponent
    }, // 该插件初始化时不需要执行任何操作
    initSubPageSearchData(plugin) {
      this.$changeOptionsEV(plugin.showSearchComponent, "isShow", false, null, this.myid, true)
      this.listPageSearchComponent.init()
    }
  },
  mixins: [subPageEventMixin],
  beforeDestroy() {
    this.listPageSearchComponent?.removeEventTrigger()
  }
}
